'use strict';

import React from 'react';
import { useState } from 'react';

import { Button, Form, Row, Col } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';

import {
    password,
    passwordRepeat,
} from '../helper/Schema';

// schema for form validation
const schema = yup.object().shape({
    Password: password,
    PasswordRepeat: passwordRepeat
});

function PasswordRecovery() {
    const { request } = useRequest();
    const [success, setSuccess] = useState(false);

    //Login Funktion
    //Wird aufgerufen wenn Formular abgesendet
    const login = async (values) => {
        try {
            let token = "";
            if (location.search.length > 0) {
                let search = location.search.slice(1);
                
                search = search.split("&");
                for (var i = 0; i < search.length; i++) {
                    let gets = search[i].split("=");
                    if (gets[0] == "token") {
                        token = gets[1];
                    }
                }
            }

            values.token = token;
            let result = await request('/Login/PasswordRecovery', values);
            let json = result.data;

            if (json.r == 0) {
                return toast.error(json.message);
            }

            setSuccess(true);
        }
        catch (ex) {
            toast.error(ex.message);
            console.error(ex);
            return;
        }
    }

    if (success) {
        return (
            <>
                <h1>Passwort wurde gespeichert</h1>
                <p>Ihr neues Passwort wurde gespeichert.</p>
                <p>Sie können sich nun mit dem neuen Passwort anmelden.</p>
            </>
        )
    }

    return (
        <Formik
            validationSchema={schema}
            onSubmit={(values) => {
                login(values);
            }}
            initialValues={{
                Password: '',
                PasswordRepeat: ''
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => (
                <>
                    <h1>Neues Passwort vergeben</h1>
                    <Row>
                        <Col xs="6">
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="Password">
                                    <Form.Label>Neues Passwort</Form.Label>
                                    <Form.Control isInvalid={errors.Password && touched.Password} type="password" placeholder="" name="Password" value={values.Password} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.Password}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="PasswordRepeat">
                                    <Form.Label>Neues Passwort wiederholen</Form.Label>
                                    <Form.Control isInvalid={errors.PasswordRepeat && touched.PasswordRepeat} type="password" placeholder="" name="PasswordRepeat" value={values.PasswordRepeat} onBlur={handleBlur} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.PasswordRepeat}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Button variant="secondary" type="submit">
                                    <i className="fa-solid fa-check mr-2"></i>Neues Passwort speichern
                                </Button>
                                
                            </Form>
                        </Col>
                    </Row>
                </>
            )}
        </Formik>
    );
}

export default PasswordRecovery;